import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import PurchaseService from "../../../services/OrderingServices/PurchaseService";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { formatDateTimes } from "../../../Components/Common/FormatDate";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { Triangle } from "react-loader-spinner";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};
const PurchaseDetail = () => {
  const { id } = useParams();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await PurchaseService.detail(id);
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },

    {
      name: "Item Name",
      selector: (row) => (
        <Link to={`/menu-item/update/${row.id}`}>{row.productName}</Link>
      ),
      sortable: true,
    },
    {
      name: "Quantity",
      selector: (row) => row.quantity,
      sortable: true,
      right: true,
    },
    {
      name: "Unit Price",
      selector: (row) => row.unitPrice,
      sortable: true,
      right: true,
    },
  ];
  const breadcrumbItems = [
    { title: "Back To List", onClick: () => navigate(-1) },
  ];
  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title="Purchase Detail"
          pageTitle="Purchase"
          breadcrumbItems={breadcrumbItems}
        />
        <Card>
          <CardBody>
            <Row>
              <Col>
                <div>
                  <h6>Purchase Date:</h6>
                  <h6>{formatDateTimes(data?.purchaseDate)}</h6>
                </div>
              </Col>
              <Col>
                <div>
                  <h6>Total Amount:</h6>
                  <h6>{data?.totalAmount}</h6>
                </div>
              </Col>
              <Col>
                <div>
                  <h6>Payment Status:</h6>
                  <h6
                    className={`badge ${data?.paymentStatus === "Pending"
                        ? "bg-warning"
                        : "bg-success"
                      }`}
                  >
                    {data?.paymentStatus}
                  </h6>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <CustomDataTable
              responsive
              striped
              pagination
              fixedHeader
              persistTableHead
              progressPending={loading}
              customStyles={customStyles}
              progressComponent={
                <div className="my-3">
                  <Triangle
                    visible={true}
                    height="80"
                    width="80"
                    color="#5B71B9"
                    ariaLabel="triangle-loading"
                  />
                  <h5 className="mt-1">Loading...</h5>
                </div>
              }
              columns={columns}
              data={data?.items}
            />
          </CardBody>
        </Card>
      </div>
    </Container>
  );
};

export default PurchaseDetail;
